import Token from "../pages/Token";

type RouteType = {
  path: string;
  component: JSX.Element;
};
export const ROUTES: RouteType[] = [{ path: "token", component: <Token /> }];

export const DEFAULT_ROUTE = "token";
